import { cleanObject } from '@teko/utils';
import { unstable_serialize } from 'swr';

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const paramToUrl = (params, baseUrl, key) => {
  const url = new URL(`${baseUrl}/${key || "search"}`);
  if (params) {
    Object.keys(params).forEach((key2) => {
      if (Array.isArray(params[key2]) && !params[key2].length)
        return;
      return url.searchParams.append(key2, params[key2]);
    });
  }
  return url;
};
const getParamsFromUrl = (url, key) => {
  if (!url) {
    return void 0;
  }
  const params = url.indexOf("?") >= 0 ? url.substring(url.indexOf("?")) : "";
  const param = new URLSearchParams(params).get(key);
  return param;
};
const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const cookFilterOption = (el, filterCode, filterName, params) => {
  var _a, _b, _c;
  const optionName = el.name || el.value || "";
  const optionCode = el.code || ((_a = el.optionId) == null ? void 0 : _a.toString()) || ((_b = el.id) == null ? void 0 : _b.toString()) || "";
  if (!params || !((_c = params[filterCode]) == null ? void 0 : _c.toString().split(",").includes(optionCode))) {
    return {
      optionName,
      optionCode,
      filterCode,
      filterName
    };
  }
  return {
    optionName: "",
    optionCode: "",
    filterCode: "",
    filterName: ""
  };
};
const cookFilter = (filter, params, categories) => {
  var _a, _b, _c;
  const newFilter = [];
  if (!filter)
    return newFilter;
  if (categories == null ? void 0 : categories.length) {
    newFilter.push({
      code: "masterCategories",
      name: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m",
      options: categories.map((val) => cookFilterOption(val, "masterCategories", "Danh m\u1EE5c s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  if ((_a = filter == null ? void 0 : filter.brands) == null ? void 0 : _a.length) {
    newFilter.push({
      code: "brands",
      name: "Th\u01B0\u01A1ng hi\u1EC7u",
      options: filter.brands.map((val) => cookFilterOption(val, "brands", "Th\u01B0\u01A1ng hi\u1EC7u", params)).filter(Boolean)
    });
  }
  if ((_b = filter == null ? void 0 : filter.clearanceTypes) == null ? void 0 : _b.length) {
    newFilter.push({
      code: "clearanceTypeIds",
      name: "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m",
      options: filter.clearanceTypes.map((val) => cookFilterOption(val, "clearanceTypeIds", "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  (_c = filter == null ? void 0 : filter.attributes) == null ? void 0 : _c.forEach((el) => {
    newFilter.push({
      code: `attributes.${el.code}`,
      name: el.name,
      options: el.values.map((val) => cookFilterOption(val, `attributes.${el.code}`, el.name, params)).filter(Boolean)
    });
  });
  return newFilter.filter((filter2) => !!filter2.options.length);
};
const normalizePageBuilderToDiscoveryParams = (params) => {
  var _a, _b, _c, _d;
  if (!params)
    return {};
  const attributes = params["attributes"] || [];
  const priceGteFromPageBuilder = (_b = (_a = params == null ? void 0 : params.prices) == null ? void 0 : _a[0]) == null ? void 0 : _b.from;
  const priceLteFromPageBuilder = (_d = (_c = params == null ? void 0 : params.prices) == null ? void 0 : _c[0]) == null ? void 0 : _d.to;
  if (!params["price_gte"] && priceGteFromPageBuilder)
    params["price_gte"] = priceGteFromPageBuilder;
  if (!params["price_lte"] && priceLteFromPageBuilder)
    params["price_lte"] = priceLteFromPageBuilder;
  attributes.forEach((element) => {
    const key = `attributes.${element.code}`;
    const value = element.optionIds && element.optionIds.toString();
    params[key] = value;
  });
  params["attributes"] = [];
  return cleanObject(params);
};
const getKeyAPI = (params, baseUrl) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const normalizedParams = normalizePageBuilderToDiscoveryParams(searchParams);
  const terminalCode = normalizedParams == null ? void 0 : normalizedParams.terminalCode;
  const pos365StoreCode = normalizedParams == null ? void 0 : normalizedParams.pos365StoreCode;
  return unstable_serialize(params && Object.keys(params).length && (!!terminalCode || !pos365StoreCode) ? [normalizedParams, baseUrl + "/search"] : null);
};

export { cookFilter, getKeyAPI, getObjFromQueryString, getParamsFromUrl, normalizePageBuilderToDiscoveryParams, paramToUrl };
